<template>
  <div>
    <div class="overlay" v-if="showLoading">
      <div div style="position:fixed;
          top: 50%;
          left: 50%;
          z-index:999999">
        <vue-loaders-ball-spin-fade-loader color="#173B6B" scale="1.5">
        </vue-loaders-ball-spin-fade-loader>
      </div>
    </div>

    <p class="titleDetailConcpetProduct">ข้อมูลแนวคิดผลิตภัณฑ์</p>
    <b-row id="formDetailColumn">
      <b-col md="6">
        <ConceptProductDetailThai></ConceptProductDetailThai>
      </b-col>

      <b-col md="6">
        <ConceptProductDetailEng></ConceptProductDetailEng>
      </b-col>

      <b-col md="12">
        <br>
        <ConceptProductDetailOverall></ConceptProductDetailOverall>
      </b-col>

    </b-row>
    <p :class="resultTextClass">{{resultText}}</p>
    <b-button v-if="!createMode" variant="danger" class="btnForm1Detail"
    @click="confirmDeleteModal=true">
      ลบ
    </b-button>
    <b-button v-if="!createMode" variant="success" class="btnForm1Detail"
    :href="previewUrl" target="_blank">
      ดูตัวอย่าง
    </b-button>
    <b-button variant="success" class="btnForm1Detail"
    @click="checkName">
      บันทึกข้อมูล
    </b-button>

    <b-modal :title="titleUpdateConceptProductModal"
    id="confirmUpdateConceptProductModal" centered class="modal-primary"
    v-model="confirmUpdateConceptProductModal">
      <div slot="modal-footer" class="w-100">
        <b-row class="float-right">
          <b-col sm="12">
            <b-btn size="lg" style="margin-right:20px;margin-top:15px;"
            class="float-right" variant="danger" @click="confirmUpdateConceptProductModal=false">
              ยกเลิก
            </b-btn>
            <b-btn size="lg" style="margin-right:20px;margin-top:15px;"
            class="float-right" variant="success" @click="updateConceptProduct">
              ยืนยัน
            </b-btn>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal :title="titleDeleteConceptProductModal"
    id="confirmDeleteSmeModal" centered class="modal-primary" v-model="confirmDeleteModal">
      <div slot="modal-footer" class="w-100">
        <b-row class="float-right">
          <b-col sm="12">
            <b-btn size="lg" style="margin-right:20px;margin-top:15px;"
            class="float-right" variant="danger" @click="confirmDeleteModal=false">
              ยกเลิก
            </b-btn>
            <b-btn size="lg" style="margin-right:20px;margin-top:15px;"
            class="float-right" variant="success"
            @click="deleConceptProduct">
              ยืนยัน
            </b-btn>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { hostURL } from '../../../config';
import ConceptProductDetailThai from './ConceptProductDetailThai.vue';
import ConceptProductDetailEng from './ConceptProductDetailEng.vue';
import ConceptProductDetailOverall from './ConceptProductDetailOverall.vue';

export default {
  components: {
    ConceptProductDetailThai,
    ConceptProductDetailEng,
    ConceptProductDetailOverall,
  },
  computed: {
    ...mapGetters('ConceptProduct', ['conceptProductDetail', 'showLoading', 'createMode']),
    ConceptProductDataName() {
      return this.conceptProductDetail.name;
    },
  },
  watch: {
    ConceptProductDataName() {
      if (this.createMode) {
        this.titleUpdateConceptProductModal = `คุณแน่ใจใช่ไหมที่สร้าง
        ${this.conceptProductDetail.name} ?`;
      } else {
        this.titleUpdateConceptProductModal = `คุณแน่ใจใช่ไหมที่แก้ไขข้อมูล
        ${this.conceptProductDetail.name} ?`;
      }
      this.titleDeleteConceptProductModal = `คุณแน่ใจใช่ไหมที่จะลบ ${this.conceptProductDetail.name} ?`;
      this.previewUrl = `${hostURL}product-concept/${this.conceptProductDetail.id}`;
    },
  },
  data() {
    return {
      confirmUpdateConceptProductModal: false,
      titleUpdateConceptProductModal: '',
      resultText: '',
      resultTextClass: '',
      confirmDeleteModal: false,
      titleDeleteConceptProductModal: '',
      previewUrl: '',
    };
  },
  methods: {
    ...mapActions('ConceptProduct', ['updateConceptProductDetail', 'updateField', 'deleteConceptProduct',
      'setCheckNameTh', 'setCheckNameEng']),
    async updateConceptProduct() {
      this.confirmUpdateConceptProductModal = false;
      const result = await this.updateConceptProductDetail();
      console.log('updateConceptProduct', this.conceptProductDetail);
      this.resultText = result ? 'อัปเดตข้อมูลสำเร็จ' : 'อัปเดตข้อมูลไม่สำเร็จ กรุณาลองใหม่หรือติดต่อแอดมิน';
      this.resultTextClass = result ? 'resultSuccess' : 'resultFail';
      if (result && this.createMode) {
        this.$router.push('/backoffice/conceptproduct/all');
      }
    },
    async deleConceptProduct() {
      this.confirmDeleteModal = false;
      const result = await this.deleteConceptProduct(this.conceptProductDetail.id);
      console.log('deleteConceptProduct', this.conceptProductDetail);
      if (result) {
        this.$router.push('/backoffice/conceptproduct/all');
      } else {
        this.resultText = 'ลบข้อมูลไม่สำเร็จ กรุณาลองใหม่หรือติดต่อแอดมิน';
        this.resultTextClass = 'resultFail';
      }
    },
    checkName() {
      let checkTh = false;
      let checkEng = false;
      let resText = '';
      this.resultText = '';
      if (this.conceptProductDetail.name !== null && this.conceptProductDetail.name !== '') {
        const nameTh = this.conceptProductDetail.name.trim();
        if (nameTh !== '') {
          checkTh = true;
          this.setCheckNameTh(false);
        } else {
          resText = 'กรุณากรอกชื่อภาษาไทย';
          this.setCheckNameTh(true);
        }
      } else {
        resText = 'กรุณากรอกชื่อภาษาไทย';
        this.setCheckNameTh(true);
      }

      if (this.conceptProductDetail.name_eng !== null && this.conceptProductDetail.name_eng !== '') {
        const nameEng = this.conceptProductDetail.name_eng.trim();
        if (nameEng !== '') {
          checkEng = true;
          this.setCheckNameEng(false);
        } else {
          resText = `${resText} กรุณากรอกชื่อภาษาอังกฤษ`;
          this.setCheckNameEng(true);
        }
      } else {
        resText = `${resText} กรุณากรอกชื่อภาษาอังกฤษ`;
        this.setCheckNameEng(true);
      }

      if (checkTh && checkEng) {
        this.confirmUpdateConceptProductModal = true;
      } else {
        this.resultText = resText;
        this.resultTextClass = 'resultFail';
      }
    },
  },
};
</script>

<style>
  .titleDetailConcpetProduct {
    font-size: 20px;
    color: #173B6B;
  }
  #formDetailColumn {
    padding: 0 20px 0 0;
  }
  .btnForm1Detail {
    float: right;
    margin: 0 20px 20px 0;
  }
  .resultSuccess {
    color: #28a745;
    font-size: 20px;
  }
  .resultFail {
    color: red;
    font-size: 20px;
  }
  .overlay {
    background-color:#EFEFEF;
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1000;
    top: 0px;
    left: 0px;
    opacity: 0.3;
  }
  .alertCheck {
    color: red;
    text-align: right;
    margin-right: 20px;
  }
</style>
